import React from 'react';

import { LanguageTranslationKeys } from 'i18n/languages/en';
import AboutPageSections from 'modules/Report/constants/AboutPageSections';

import { AboutPageSectionType } from '@common/modules/Report/types';

import ReportAboutItem from './Item';
import StyledReportAboutPageWrap from './styled';

function AboutPage() {
	return (
		<StyledReportAboutPageWrap>
			{AboutPageSections.map((section: AboutPageSectionType<LanguageTranslationKeys>) => (
				<ReportAboutItem {...section} key={section.title} />
			))}
		</StyledReportAboutPageWrap>
	);
}

export default AboutPage;
